(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fi-brand-filter"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('fi-brand-filter')) {
    customElements.define('fi-brand-filter', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const input = this.querySelector('input');
        const list = this.querySelector('ul');
        if (!input || !list) return;
        const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().trim();
        const seen = new Set();
        Array.from(list.children).forEach(item => {
          const anchor = item.querySelector('a');
          const key = normalize(anchor.textContent) + '|' + anchor.getAttribute('href');
          if (seen.has(key)) item.remove();
          else seen.add(key);
        });
        const items = Array.from(list.children).sort((a, b) => a.textContent.trim().localeCompare(b.textContent.trim(), undefined, {sensitivity: 'base'}));
        items.forEach(item => list.append(item));
        const empty = this.querySelector('.fi-brand-filter__empty');
        const status = this.querySelector('[role="status"]');
        const filter = () => {
          const term = normalize(input.value);
          let count = 0;
          items.forEach(item => {
            item.hidden = !normalize(item.textContent).includes(term);
            if (!item.hidden) count++;
          });
          empty.hidden = count > 0;
          status.textContent = count + ' ' + status.dataset.countLabel;
          this.querySelector('.fi-brand-filter__scroll').scrollTop = 0;
        };
        input.addEventListener('input', filter, {signal: this.controller.signal});
        input.addEventListener('search', filter, {signal: this.controller.signal});
        filter();
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }
  if (!customElements.get('fi-brand-dropdown')) {
    customElements.define('fi-brand-dropdown', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = {signal: this.controller.signal};
        const details = this.querySelector('details');
        const summary = details.querySelector('summary');
        const close = () => { details.open = false; };
        this.addEventListener('pointerenter', event => {
          clearTimeout(this.closeTimer);
          if (this.dataset.trigger === 'hover' && event.pointerType === 'mouse') details.open = true;
        }, options);
        this.addEventListener('pointerleave', () => {
          if (!this.contains(document.activeElement)) this.closeTimer = setTimeout(close, 150);
        }, options);
        this.addEventListener('keydown', event => {
          if (event.key === 'Escape') {
            event.stopPropagation();
            close();
            summary.focus();
          }
        }, options);
        this.addEventListener('focusout', event => {
          if (!this.contains(event.relatedTarget)) close();
        }, options);
        document.addEventListener('pointerdown', event => {
          if (!this.contains(event.target)) close();
        }, options);
      }
      disconnectedCallback() { this.controller?.abort(); clearTimeout(this.closeTimer); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["fi-note-filter"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('fi-note-filter')) {
    const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().replace(/[^\p{L}\p{N}]+/gu, ' ').trim();
    const indexes = new Map();
    const states = new Map();
    customElements.define('fi-note-filter', class extends HTMLElement {
      async connectedCallback() {
        this.controller?.abort();
        const controller = this.controller = new AbortController();
        const options = { signal: controller.signal };
        const input = this.querySelector('input[type="search"]');
        input.addEventListener('change', event => event.stopPropagation(), options);
        input.addEventListener('keydown', event => {
          if (event.key === 'Enter') { event.preventDefault(); event.stopPropagation(); }
        }, options);
        const url = this.dataset.indexUrl;
        if (!indexes.has(url)) {
          indexes.set(url, fetch(url).then(response => {
            if (!response.ok) throw new Error('Note index unavailable');
            return response.json();
          }).catch(error => { indexes.delete(url); throw error; }));
        }
        let index;
        try { index = await indexes.get(url); } catch { return; }
        if (controller.signal.aborted || !this.isConnected) return;
        const groups = new Map(index.groups.map(group => [normalize(group.label), group]));
        const key = location.pathname + '|' + this.dataset.context;
        const state = states.get(key) || { term: '', expanded: new Set() };
        states.set(key, state);
        const parameter = 'filter.p.m.custom.note_filter';
        const selected = new Set(new URL(location.href).searchParams.getAll(parameter).flatMap(value => value.split(',')));
        const rows = Array.from(this.querySelectorAll('[data-group]')).map(row => {
          const group = groups.get(normalize(row.dataset.group));
          const groupInput = row.querySelector('input[type="checkbox"]');
          const details = row.querySelector('details');
          const list = details.querySelector('ul');
          list.replaceChildren();
          const members = (group?.notes || []).map(note => {
            const item = document.createElement('li');
            const label = document.createElement('label');
            const checkbox = document.createElement('input');
            checkbox.type = 'checkbox';
            checkbox.name = parameter;
            checkbox.value = note.id;
            checkbox.id = this.dataset.context + '-note-' + note.id.split('/').pop();
            checkbox.checked = selected.has(note.id);
            label.htmlFor = checkbox.id;
            label.append(checkbox, document.createTextNode(note.label));
            item.append(label);
            list.append(item);
            return { item, checkbox, terms: [note.label, ...note.aliases].map(normalize) };
          });
          const refined = members.some(member => member.checkbox.checked);
          if (refined) groupInput.checked = false;
          groupInput.indeterminate = refined;
          details.hidden = members.length === 0;
          details.querySelector('[data-contents-label]').textContent = this.dataset.contentsLabel.replace('[count]', members.length);
          details.open = refined || state.expanded.has(row.dataset.group);
          details.addEventListener('toggle', () => {
            if (details.open) state.expanded.add(row.dataset.group);
            else state.expanded.delete(row.dataset.group);
          }, options);
          groupInput.addEventListener('change', () => {
            members.forEach(member => { member.checkbox.checked = false; });
            groupInput.indeterminate = false;
          }, options);
          members.forEach(({ checkbox }) => checkbox.addEventListener('change', () => {
            groupInput.checked = false;
            groupInput.indeterminate = members.some(member => member.checkbox.checked);
          }, options));
          return { row, groupInput, details, members, label: normalize(row.dataset.group), position: row.parentElement.children.length ? Array.from(row.parentElement.children).indexOf(row) : 0 };
        });
        const selectedPanel = this.querySelector('.fi-note-filter__selected');
        const updateSelected = () => {
          const count = rows.reduce((sum, row) => sum + row.members.filter(member => member.checkbox.checked).length, 0);
          selectedPanel.hidden = count === 0;
          this.querySelector('[data-selected-count]').textContent = this.dataset.selectedLabel.replace('[count]', count);
        };
        this.addEventListener('change', updateSelected, options);
        this.querySelector('[data-clear-notes]').addEventListener('click', () => {
          rows.forEach(({ groupInput, members }) => {
            members.forEach(member => { member.checkbox.checked = false; });
            groupInput.indeterminate = false;
          });
          updateSelected();
          this.dispatchEvent(new Event('change', { bubbles: true }));
        }, options);
        updateSelected();
        const clear = this.querySelector('[data-clear]');
        const update = () => {
          state.term = input.value;
          const terms = normalize(input.value).split(' ').filter(Boolean);
          const matches = text => terms.every(term => text.includes(term));
          const phrase = normalize(input.value);
          let count = 0;
          rows.forEach(({ row, details, members, label, groupInput }) => {
            let memberMatch = false;
            members.forEach(({ item, terms: aliases }) => {
              const matched = terms.length > 0 && aliases.some(matches);
              item.toggleAttribute('data-match', matched);
              memberMatch ||= matched;
            });
            const hasSelection = groupInput.checked || members.some(member => member.checkbox.checked);
            row.hidden = terms.length > 0 && !matches(label) && !memberMatch && !hasSelection;
            if (!row.hidden) count++;
            if (terms.length && memberMatch) details.open = true;
          });
          const score = row => row.members.some(member => member.terms.includes(phrase)) ? 2 : row.label === phrase ? 1 : 0;
          const ordered = terms.length ? [...rows].sort((a, b) => score(b) - score(a) || a.position - b.position) : rows;
          const container = this.querySelector('.fi-note-filter__groups');
          ordered.forEach(({ row }) => container.append(row));
          clear.hidden = terms.length === 0;
          this.querySelector('[data-empty]').hidden = count !== 0;
          this.querySelector('[role="status"]').textContent = this.dataset.countLabel.replace('[count]', count);
          this.querySelector('.fi-note-filter__groups').scrollTop = 0;
        };
        input.value = state.term;
        input.addEventListener('input', update, options);
        clear.addEventListener('click', () => { input.value = ''; update(); input.focus(); }, options);
        this.querySelector('.fi-note-filter__tools').hidden = false;
        update();
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
